var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-results playlist-results"},_vm._l((_vm.items),function(item,index){return _c('PlaylistCard',{key:`${item.meta?.source}-${index}`,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }